const dev = {
  localStorageKey: "MyLookLocalStorage",
  baseURL: "http://localhost:3001",
  playersBaseURL: "http://localhost:3002",
  imagesBaseURL: "https://images.staging.mysign.demopad.com",
  recaptchaSiteKey: "6LcD22cqAAAAABTzBSLghlV_a07LIOBUMpYK0Oo6",
  s3Bucket: "mylook-player-content",
  s3Region: "eu-west-1",
  awsAccessKeyId: "AKIAIOLWPARNSYK27RYA"
};


const staging = {
  localStorageKey: "MyLookLocalStorageStaging",
  baseURL: "https://mylook-api.staging.mysign.demopad.com",
  playersBaseURL: "https://players.staging.mysign.demopad.com",
  imagesBaseURL: "https://images.staging.mysign.demopad.com",
  recaptchaSiteKey: "6LdQ1rUrAAAAAF3rOWPeCxyZ0YkrUp9Bud2P1hII",
  s3Bucket: "mylook-player-content-staging",
  s3Region: "eu-west-1",
  awsAccessKeyId: "AKIAX2KZPZFYSXHRNCG5"
};

const prod = {
  localStorageKey: "MyLookLocalStorageProduction",
  baseURL: "https://api.cloudsignage.me",
  playersBaseURL: "https://players.cloudsignage.me",
  imagesBaseURL: "https://images.cloudsignage.me",
  recaptchaSiteKey: "6LcD22cqAAAAABTzBSLghlV_a07LIOBUMpYK0Oo6",
  s3Bucket: "mylook-player-content",
  s3Region: "eu-west-1",
  awsAccessKeyId: "AKIAIOLWPARNSYK27RYA"
};

let config;

switch (process.env.REACT_APP_STAGE) {
  case 'development':
    config = dev;
    break;
  case 'staging':
    config = staging;
    break;
  default:
    config = prod;
}

export default {
  ...config
};
